import React from 'react';
import ReactDOM from 'react-dom/client';
import { ChakraProvider, extendTheme } from '@chakra-ui/react';
import App from './App';

// Custom theme for PyFR / SRS simulations platform
const theme = extendTheme({
  colors: {
    brand: {
      50: '#e0f7fa',
      100: '#b2ebf2',
      500: '#0891b2',
      600: '#0e7490',
      700: '#155e75',
      900: '#083344',
    },
    accent: {
      50: '#fce7f3',
      100: '#fbcfe8',
      500: '#db2777',
      600: '#be185d',
      700: '#9d174d',
      900: '#500724',
    },
  },
  fonts: {
    heading: 'Inter, system-ui, sans-serif',
    body: 'Inter, system-ui, sans-serif',
  },
  styles: {
    global: {
      body: {
        bg: 'gray.50',
      },
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ChakraProvider theme={theme}>
      <App />
    </ChakraProvider>
  </React.StrictMode>
); 